export const HEAP_SHARE_EVENT_ACTION = 'ShareEventButtonClick';
export const HEAP_SHARE_EVENT_METHOD = 'ShareEventMethodButtonClicked';
export const HEAP_SHARE_EVENT_CLOSE_MODAL = 'ShareEventCloseModalButtonClick';
